// extracted by mini-css-extract-plugin
module.exports = {"gauge":"e_Pwb","ring":"e_Qwb","ringText":"e_Rwb","ringVal":"e_Swb","ringMax":"e_Twb","label":"e_Uwb","labelClamp":"e_Vwb","sub":"e_Wwb"};